import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||71}
    height={props.width?`calc(${props.width}/71*143)`:143}
    viewBox="0 0 71 143"
    fill="none"
    {...props}
  >
    <path fill={props.color||"#00C9D6"} d="m0 71.606 70.803 70.802V.803L0 71.606Z" />
    <path stroke="#fff" d="M41 83 30 72l11-11" />
    <path stroke="#fff" d="M50 83 39 72l11-11" />
  </svg>
)
export default SvgComponent
